import React from "react";
import { Alert, Container } from "reactstrap";
// import { RiErrorWarningFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { IoCloseCircleOutline } from "react-icons/io5";

import suggestion_iocn from "../../assets/suggestion.svg";

export default function BuyPointNotification({ point, onClose }) {
  return (
    <div className="buy_point_notification">
      <Container fluid>
        <Alert isOpen={point} fade={true}>
          <div className="notifaction">
            <div className="notification-text">
              <span className="icon">
                <img src={suggestion_iocn} alt="" />
              </span>{" "}
              <span className="content">
                New premium features are just one click away, to use them Buy
                credits and experience the difference.
              </span>
            </div>
          </div>
          <div className="buttons-cls">
            <Link
              to="/points"
              style={{ backgroundColor: "#F47F31" }}
              className="btn"
            >
              Buy Credits
            </Link>
            <div className="close-btn" onClick={onClose}>
              <IoCloseCircleOutline size={25} color="#6F6F6F" />
            </div>
          </div>
        </Alert>
      </Container>
    </div>
  );
}
